export default () => {
  const authorBlock = document.querySelector('[data-author-block]');
  const authorInfoElement = document.querySelector('[data-author-info]');
  const authorContentElement = document.querySelector('[data-author-content]');

  if (!authorBlock) {
    return;
  }
  if (!authorInfoElement || authorInfoElement.textContent === 'false') {
    return;
  }

  const authorInfo = JSON.parse(decodeURIComponent(authorInfoElement.textContent));

  if (authorContentElement) {
    authorContentElement.innerHTML = authorInfo.user_description;
  }
};
